import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'
import { JobSeekerForm } from './common/JobSeekerForm'

import styles from './AddJobSeekerModal.module.scss'
import { useJobSeekerModalState } from './hooks'

export const JobSeekerModal = ({
  candidate,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useJobSeekerModalState(
    { candidate, isOpen },
    { onCancel, onClose, onConfirm },
  )

  const {
    form: { control, formState },
    languages,
    isConfirmationOpen,
  } = state
  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
  } = handlers
  return (
    <React.Fragment>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        title={candidate ? t`Edit person` : t`Add person`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <JobSeekerForm {...{ control, formState, languages }} />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </React.Fragment>
  )
}
